import { applyFilters, hasFilter } from '@wordpress/hooks';
import { useSelect, select, dispatch, withSelect } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { TabPanel, PanelRow, ToggleControl, RadioControl, Popover, Button, Icon, TextControl, Modal, SelectControl, CheckboxControl, TextareaControl, FormTokenField } from '@wordpress/components';

// Feilds.
import TripEnquiryFields from './fields/TripEnquiryFields';
import BillingFields from './fields/BillingFields';
import TravelerFields from './fields/TravelerFields';

import { useState, useEffect } from '@wordpress/element';

export default () => {

    const settings = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { updateSettings } = dispatch('WPTravel/Admin');
    const { field_editors, enquiry_fields, billing_fields, traveller_fields, options, modules } = settings

    const { default_settings } = options;
    const { modules: defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys(modules).length > 0 ? modules : defaultModules;



    const isActive = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_field_editor && 'yes' === moduleSettings.show_wp_travel_field_editor.value;
    if (!isActive) {
        // To hide while disabling from addons settings.
        return <></>;
    }

    const { fields_options, heading_tags, trip_type_options, trip_activities_options } = options.field_editors

    const resetFields = (field) => {
        if (window.confirm('Are you sure to reset this fields?')) {
            let defaultFileds = field_editors.enquiry_default
            if ('billing' == field) {
                defaultFileds = field_editors.billing_default
            } else if ('traveller' == field) {
                defaultFileds = field_editors.traveller_default
            }
            updateSettings({ ...settings, field_editors: { ...settings.field_editors, [field]: defaultFileds } })
        }
    }

    const sortFields = (sortedList, field) => {

        // Update priority.
        let priority = 0
        let prioritySorting = sortedList.map((list) => {
            priority += 10;
            list.priority = priority
            return list
        })

        updateSettings({ ...settings, field_editors: { ...settings.field_editors, [field]: prioritySorting } })
    }

    // For popover
    const [{
        isVisible, fieldData, isNewField
    }, setState] = useState({
        isVisible: false,
        isNewField: false,
        fieldData: {}
    })

    const toggleVisible = (fieldName, fieldType) => { // @field_type enquiry | billing | traveler
        if ('undefined' != typeof isVisible) {
            setState((state) => ({
                isVisible: !state.isVisible,
                isNewField: fieldName ? false : true
            }));

            let editorFields = enquiry_fields;
            if (fieldType) {
                switch (fieldType) {
                    case 'billing':
                        editorFields = billing_fields
                        break;
                    case 'traveller':
                        editorFields = traveller_fields
                        break;

                }
            }

            // only for edit.
            if (fieldName) {
                let fields = editorFields.filter((field) => { return field.name == fieldName })
                if ('undefined' != typeof fields[0]) {
                    setState((prevState) => {
                        return { ...prevState, fieldData: fields[0] }
                    })
                }
            } else { // Add New.
                let newField = {
                    attributes: {
                    },
                    chosen: false,
                    id: "",
                    // key: "",
                    label: "",
                    name: "",
                    priority: ((editorFields.length) + 1) * 10,
                    selected: false,
                    type: "text",
                    validations: {
                        maxlength: "60",
                        required: false
                    },
                    wrapper_class: "",
                    conditional_rendering: {
                        condtional_logic: [
                            [
                                {
                                    trip_category: 'trip_type',
                                    condition: 'all',
                                    term_value: '',
                                }
                            ]
                        ]
                    }
                    // _default: false
                }
                setState((prevState) => {
                    return { ...prevState, fieldData: newField }
                })
            }
        }
    };

    // For conditonal logic.

    // for add fields.
    const handleAddFields = () => {
        const values = 'undefined' != typeof fieldData && 'undefined' != typeof fieldData.conditional_rendering && [...fieldData.conditional_rendering.condtional_logic];
        values.push([{ trip_category: 'trip_type', condition: 'all', term_value: '' }]);
        let _fieldData = fieldData
        _fieldData.conditional_rendering.condtional_logic = values

        setState((prevState) => {
            return { ...prevState, fieldData: _fieldData }
        })
    }

    // for add rule.
    const handleAndFields = (index, innerIndex) => {
        let values = 'undefined' != typeof fieldData && 'undefined' != typeof fieldData.conditional_rendering && [...fieldData.conditional_rendering.condtional_logic[index]];
        values.push({ trip_category: 'trip_type', condition: 'all', term_value: '' });
        let _fieldData = fieldData
        _fieldData.conditional_rendering.condtional_logic[index] = values

        setState((prevState) => {
            return { ...prevState, fieldData: _fieldData }
        })
    }

    const handleRemoveFields = (index, innerIndex) => {
        if (innerIndex == 0) { // For removing 'OR' fields
            const values = 'undefined' != typeof fieldData && 'undefined' != typeof fieldData.conditional_rendering && [...fieldData.conditional_rendering.condtional_logic];
            values.splice(index, 1);
            let _fieldData = fieldData
            _fieldData.conditional_rendering.condtional_logic = values

            setState((prevState) => {
                return { ...prevState, fieldData: _fieldData }
            })
        } else { // For removing 'AND' fields
            const values = 'undefined' != typeof fieldData && 'undefined' != typeof fieldData.conditional_rendering && [...fieldData.conditional_rendering.condtional_logic[index]];
            values.splice(innerIndex, 1);
            let _fieldData = fieldData
            _fieldData.conditional_rendering.condtional_logic[index] = values

            setState((prevState) => {
                return { ...prevState, fieldData: _fieldData }
            })
        }
    }

    const WPTravelFieldEditorPopover = (fieldType) => {

        let selectedDateOption = 'any';
        if ('undefined' != typeof fieldData && 'undefined' != typeof fieldData.attributes && 'undefined' != typeof fieldData.attributes['data-max-today']) {
            if (fieldData.attributes['data-max-today']) {
                selectedDateOption = 'past'
            } else {
                selectedDateOption = 'future'
            }
        }
        let popoverTitle = _wp_travel.setting_strings.field_editor.enquiry_field
        if (fieldType) {
            switch (fieldType) {
                case 'billing':
                    popoverTitle = _wp_travel.setting_strings.field_editor.billing_field
                    break;
                case 'traveller':
                    popoverTitle = _wp_travel.setting_strings.field_editor.travelers_field
                    break;
            }
        }

        return <>
            {'undefined' != typeof isVisible && isVisible && 'undefined' != typeof fieldData && (
                <div className="popover-wrapper" >
                    <Modal
                        onRequestClose={toggleVisible}
                        title={popoverTitle}
                    >
                        <form id="field-editor-popup-form">
                            <div className="wp-travel-form-field ">
                                <label htmlFor="editor_label">{_wp_travel.setting_strings.field_editor.field_editor_label }<span className="required-label">*</span> </label>
                                <TextControl
                                    value={fieldData.label}
                                    placeholder={__('Enter field label', 'wp-travel-pro')}
                                    onChange={
                                        (value) => {
                                            let _fieldData = fieldData
                                            _fieldData = JSON.parse(JSON.stringify(_fieldData))
                                            _fieldData.label = value

                                            if (isNewField) {
                                                _fieldData.name = value.replace(/-/g, "_").replace(/ /g, "_");
                                            }

                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })
                                        }
                                    }
                                    required={true}
                                    id="editor_label"
                                />
                            </div>
                            <div className="wp-travel-form-field ">
                                <label htmlFor="editor_type" >Type<span className="required-label">*</span> </label>
                                <SelectControl
                                    value={fieldData.type}
                                    onChange={
                                        (value) => {
                                            let _fieldData = fieldData
                                            _fieldData.type = value

                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })
                                        }
                                    }
                                    options={fields_options}
                                    required={true}
                                    id="editor_type"
                                    disabled={('undefined' == typeof fieldData._default || ('undefined' != typeof fieldData._default && !fieldData._default)) ? false : true}
                                />
                            </div>

                            <div className="wp-travel-form-field ">
                                <label htmlFor="editor_name">Name<span className="required-label">*</span> </label>
                                <TextControl
                                    value={fieldData.name}
                                    placeholder={__('Enter field name', 'wp-travel-pro')}
                                    onChange={
                                        (value) => {
                                            let _fieldData = fieldData
                                            _fieldData.name = value

                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })
                                        }
                                    }
                                    required={true}
                                    id="editor_name"
                                    disabled={('undefined' == typeof fieldData._default || ('undefined' != typeof fieldData._default && !fieldData._default)) ? false : true}

                                />
                            </div>
                            <div className="wp-travel-form-field ">
                                <label htmlFor="editor_id">ID<span className="required-label">*</span> </label>
                                <TextControl
                                    value={fieldData.id}
                                    placeholder={__('Enter field ID', 'wp-travel-pro')}
                                    onChange={
                                        (value) => {
                                            let _fieldData = fieldData
                                            _fieldData.id = value

                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })
                                        }
                                    }
                                    required={true}
                                    id="editor_id"
                                    disabled={('undefined' == typeof fieldData._default || ('undefined' != typeof fieldData._default && !fieldData._default)) ? false : true}

                                />
                            </div>
                            <div className="wp-travel-form-field ">
                                <label htmlFor="editor_class">{__('Class', 'wp-travel-pro')}</label>
                                <TextControl
                                    value={'undefined' != typeof fieldData.wrapper_class ? fieldData.wrapper_class : ''}
                                    placeholder={__('Enter field Class', 'wp-travel-pro')}
                                    onChange={
                                        (value) => {
                                            let _fieldData = fieldData
                                            _fieldData.wrapper_class = value

                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })
                                        }
                                    }
                                    id="editor_class"
                                />
                            </div>
                            {('heading' != fieldData.type && 'radio' != fieldData.type && 'checkbox' != fieldData.type) &&
                                <div className="wp-travel-form-field ">
                                    <label htmlFor="editor_placeholder">Placeholder</label>
                                    <TextControl
                                        value={'undefined' != typeof fieldData.attributes && 'undefined' != typeof fieldData.attributes.placeholder ? fieldData.attributes.placeholder : ''}
                                        placeholder={
                                            'textarea' == fieldData.type ? __('Enter some notes...', 'wp-travel-pro') : __('Enter field placeholder', 'wp-travel-pro')}
                                        onChange={
                                            (value) => {
                                                let _fieldData = fieldData
                                                if ('undefined' === typeof _fieldData.attributes) {
                                                    _fieldData.attributes = {}
                                                }
                                                _fieldData.attributes.placeholder = value

                                                setState((prevState) => {
                                                    return { ...prevState, fieldData: _fieldData }
                                                })
                                            }
                                        }
                                        id="editor_placeholder"
                                    />
                                </div>
                            }
                            {('select' == fieldData.type || 'radio' == fieldData.type || 'checkbox' == fieldData.type) &&
                                <div className="wp-travel-form-field ">
                                    <label htmlFor="editor_options">Select Options </label>
                                    <FormTokenField
                                        label=""
                                        value={typeof fieldData.options !== 'undefined' && typeof Object.values(fieldData.options) !== 'undefined' ? Object.values(fieldData.options) : (fieldData.options ? fieldData.options : [])}
                                        onChange={tokens => {
                                            let _fieldData = fieldData
                                            _fieldData.options = tokens

                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })

                                        }}

                                        id="editor_options"
                                    />
                                </div>
                            }

                            {'heading' == fieldData.type &&
                                <div className="wp-travel-form-field ">
                                    <label htmlFor="editor_heading_tag" >Heading Tag</label>
                                    <SelectControl
                                        value={'undefined' != typeof fieldData.attributes && 'undefined' != typeof fieldData.attributes.heading_tag ? fieldData.attributes.heading_tag : 'h1'} // e.g: value = [ 'a', 'c' ]
                                        onChange={
                                            (value) => {
                                                let _fieldData = fieldData
                                                _fieldData.attributes.heading_tag = value

                                                setState((prevState) => {
                                                    return { ...prevState, fieldData: _fieldData }
                                                })
                                            }
                                        }
                                        options={heading_tags}
                                        id="editor_heading_tag"
                                    />
                                </div>
                            }

                            {('heading' != fieldData.type && 'recaptcha_v2' != fieldData.type) &&
                                <div className="wp-travel-form-field ">
                                    <label htmlFor="editor_validation">{_wp_travel.setting_strings.field_editor.validation }</label>
                                    <CheckboxControl
                                        label={_wp_travel.setting_strings.field_editor.required }
                                        checked={'undefined' != typeof fieldData.validations && 'undefined' != typeof fieldData.validations.required ? fieldData.validations.required : false}
                                        onChange={(value) => {
                                            let _fieldData = fieldData
                                            if ('undefined' === typeof _fieldData.validations) {
                                                _fieldData.validations = {}
                                            }
                                            _fieldData.validations.required = value
                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })
                                        }}
                                        id="editor_validation"
                                    />
                                </div>
                            }

                            {(fieldType && 'traveller' == fieldType) &&
                                <div className="wp-travel-form-field ">
                                    <label htmlFor="editor_validation">{_wp_travel.setting_strings.field_editor.required_for_all_travelers }</label>
                                    <CheckboxControl
                                        label={_wp_travel.setting_strings.field_editor.required_for_all_travelers}
                                        checked={'undefined' != typeof fieldData.validations && 'undefined' != typeof fieldData.validations.required_for_all ? fieldData.validations.required_for_all : false}
                                        onChange={(value) => {
                                            let _fieldData = fieldData
                                            if ('undefined' === typeof _fieldData.validations) {
                                                _fieldData.validations = {}
                                            }
                                            _fieldData.validations.required_for_all = value
                                            if (_fieldData.validations.required_for_all == true) {
                                                if (_fieldData.remove_field) {
                                                    _fieldData.remove_field = false;
                                                }
                                            }
                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })
                                        }}
                                        id="editor_validation"
                                    />
                                </div>
                            }
                            {(fieldType && 'traveller' == fieldType) &&
                                <div className="wp-travel-form-field ">
                                    <label htmlFor="editor_validation">{_wp_travel.setting_strings.field_editor.remove_field }</label>

                                    <CheckboxControl
                                        label={_wp_travel.setting_strings.field_editor.remove_field_travelers }
                                        help={_wp_travel.setting_strings.field_editor.remove_field_note }
                                        checked={'undefined' !== typeof fieldData && 'undefined' !== typeof fieldData.remove_field ? fieldData.remove_field : false}
                                        onChange={(value) => {
                                            let _fieldData = fieldData
                                            if ('undefined' === typeof _fieldData) {
                                                _fieldData = {}
                                            }
                                            if (_fieldData.validations) {
                                                if (_fieldData.validations.required_for_all) {
                                                    if (_fieldData.validations.required_for_all == false) {
                                                        _fieldData.remove_field = value;
                                                    } else {
                                                        _fieldData.remove_field = false;
                                                    }
                                                } else {
                                                    _fieldData.remove_field = value;
                                                }
                                            } else {
                                                _fieldData.remove_field = value;
                                            }
                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })
                                        }}
                                        id="editor_validation"
                                    />
                                </div>
                            }

                            {fieldData && ("undefined" != typeof fieldData.conditional_rendering && 'undefined' != typeof fieldData.conditional_rendering.conditional_rendering && fieldData.conditional_rendering.conditional_rendering) &&
                                <PanelRow>
                                    <strong><label>Render this field if</label></strong>
                                </PanelRow>
                            }

                            {/**Field Render. */}
                            {fieldData && ("undefined" != typeof fieldData.conditional_rendering && 'undefined' != typeof fieldData.conditional_rendering.conditional_rendering && fieldData.conditional_rendering.conditional_rendering) &&
                                fieldData.conditional_rendering.condtional_logic.map((inputField, index) => ( // First array looping.
                                    inputField.length > 0 &&
                                    inputField.map((innerInputField, innerIndex) => ( // For reference : Inner array looping. ( In 'OR' condition, array structure is array(array()) i.e single array inside array, while in 'AND' condition its array(array(),array()...array())) i.e Multiple arrays inside an array.
                                        <>
                                            {/**
                                                 * To make sure 'OR' is not display on frontend while adding field from 'AND'.
                                                 */}
                                            {index != 0 && innerIndex == 0 &&
                                                <PanelRow>
                                                    <div className="wp-travel-form-field">
                                                        <label>{__('OR', 'wp-travel-pro')}</label>
                                                    </div>
                                                </PanelRow>
                                            }
                                            {/**Main Wrapper. */}
                                            <PanelRow key={innerIndex}>
                                                {/**Select options. */}
                                                <div className="wp-travel-form-field">
                                                    <SelectControl
                                                        value={innerInputField.trip_category}
                                                        onChange={
                                                            (value) => {
                                                                let _fieldData = fieldData
                                                                _fieldData.conditional_rendering.condtional_logic[index][innerIndex].trip_category = value

                                                                setState((prevState) => {
                                                                    return { ...prevState, fieldData: _fieldData }
                                                                })
                                                            }
                                                        }
                                                        options={[
                                                            { value: 'trip_type', label: 'Trip Type' },
                                                            { value: 'trip_activities', label: 'Trip Activities' },
                                                        ]}
                                                        id={"trip_category_" + innerIndex}
                                                    />
                                                </div>
                                                {/**Condition options. */}
                                                <div className="wp-travel-form-field">
                                                    <SelectControl
                                                        value={innerInputField.condition}
                                                        onChange={
                                                            (value) => {
                                                                let _fieldData = fieldData
                                                                _fieldData.conditional_rendering.condtional_logic[index][innerIndex].condition = value

                                                                setState((prevState) => {
                                                                    return { ...prevState, fieldData: _fieldData }
                                                                })
                                                            }
                                                        }
                                                        options={[
                                                            { value: 'all', label: 'Has any value' },
                                                            { value: 'equal', label: 'Equal to' },
                                                            { value: 'not_equal', label: 'Not Equal to' },
                                                        ]}
                                                        id={"trip_condition_" + innerIndex}
                                                    />
                                                </div>
                                                {   // Trip Type options.
                                                    'undefined' != typeof fieldData.conditional_rendering.condtional_logic && 'trip_type' == fieldData.conditional_rendering.condtional_logic[index][innerIndex].trip_category && 'all' != fieldData.conditional_rendering.condtional_logic[index][innerIndex].condition &&
                                                    <div className="wp-travel-form-field">
                                                        <SelectControl
                                                            value={innerInputField.term_value}
                                                            onChange={
                                                                (value) => {
                                                                    let _fieldData = fieldData
                                                                    _fieldData.conditional_rendering.condtional_logic[index][innerIndex].term_value = value

                                                                    setState((prevState) => {
                                                                        return { ...prevState, fieldData: _fieldData }
                                                                    })
                                                                }
                                                            }
                                                            options={trip_type_options.length > 0 ? trip_type_options : [{ value: '', label: 'Empty Type' }]}
                                                            disabled={trip_type_options.length > 0 ? false : true}
                                                            id={"term_name_" + innerIndex}
                                                        />
                                                    </div>
                                                }
                                                {   // Trip Activities option.
                                                    'undefined' != typeof fieldData.conditional_rendering.condtional_logic && 'trip_activities' == fieldData.conditional_rendering.condtional_logic[index][innerIndex].trip_category && 'all' != fieldData.conditional_rendering.condtional_logic[index][innerIndex].condition &&
                                                    <div className="wp-travel-form-field">
                                                        <SelectControl
                                                            value={innerInputField.term_value}
                                                            onChange={
                                                                (value) => {
                                                                    let _fieldData = fieldData
                                                                    _fieldData.conditional_rendering.condtional_logic[index][innerIndex].term_value = value

                                                                    setState((prevState) => {
                                                                        return { ...prevState, fieldData: _fieldData }
                                                                    })
                                                                }
                                                            }
                                                            options={trip_activities_options.length > 0 ? trip_activities_options : [{ value: '', label: 'Empty Activity' }]}
                                                            disabled={trip_activities_options.length > 0 ? false : true}
                                                            id={"trip_activities_" + innerIndex}
                                                        />
                                                    </div>
                                                }
                                                {/**And rule button. */}
                                                <div className="wp-travel-form-field">
                                                    <Button isSecondary onClick={() => handleAndFields(index, innerIndex)} >{__('AND', 'wp-travel-pro')}</Button>
                                                </div>
                                                {   // Remove field button.
                                                    (fieldData.conditional_rendering.condtional_logic.length >= 1 && fieldData.conditional_rendering.condtional_logic[index].length >= 1) &&
                                                    <Button isDestructive onClick={() => handleRemoveFields(index, innerIndex)} >{__('X', 'wp-travel-pro')}</Button>
                                                }
                                            </PanelRow>
                                        </>
                                    ))
                                ))}
                            {   // Add field button.
                                fieldData && ("undefined" != typeof fieldData.conditional_rendering && 'undefined' != typeof fieldData.conditional_rendering.conditional_rendering && fieldData.conditional_rendering.conditional_rendering) &&
                                <div className="wp-travel-form-field">
                                    <Button isSecondary onClick={() => handleAddFields()} >{__('Add Rule', 'wp-travel-pro')}</Button>
                                </div>
                            }

                            {/**Conditional logic part ends here. */}

                            {('date' == fieldData.type) &&
                                <div className="wp-travel-form-field ">
                                    <label htmlFor="editor_validation">Date Select Option</label>
                                    <RadioControl
                                        selected={selectedDateOption}
                                        options={[
                                            { label: 'Past dates (Including current date)', value: 'past' },
                                            { label: 'Future dates (Including current date)', value: 'future' },
                                            { label: 'Any dates', value: 'any' },
                                        ]}
                                        onChange={(option) => {
                                            let _fieldData = fieldData
                                            _fieldData.attributes['data-max-today'] = null;
                                            if ('past' == option) {
                                                _fieldData.attributes['data-max-today'] = true
                                            } else if ('future' == option) {
                                                _fieldData.attributes['data-max-today'] = false
                                            } else {
                                                delete _fieldData.attributes['data-max-today']
                                            }
                                            setState((prevState) => {
                                                return { ...prevState, fieldData: _fieldData }
                                            })

                                        }}
                                    />
                                </div>
                            }
                            {(fieldType && 'traveller' == fieldType) &&
                                <div>
                                    <div className="wp-travel-form-field ">
                                        <label htmlFor="editor_validation">{_wp_travel.setting_strings.field_editor.for_specific_trips}</label>
                                        <CheckboxControl
                                            label={_wp_travel.setting_strings.field_editor.enable_to_show_on_specific_trips_only}
                                            checked={'undefined' != typeof fieldData.validations && 'undefined' != typeof fieldData.validations.specific_trip ? fieldData.validations.specific_trip : false}
                                            onChange={(value) => {
                                                let _fieldData = fieldData
                                                if ('undefined' === typeof _fieldData.validations) {
                                                    _fieldData.validations = {}
                                                }
                                                _fieldData.validations.specific_trip = value
                                                if (_fieldData.validations.specific_trip == true) {
                                                    if (_fieldData.remove_field) {
                                                        _fieldData.remove_field = false;
                                                    }
                                                }
                                                setState((prevState) => {
                                                    return { ...prevState, fieldData: _fieldData }
                                                })
                                            }}
                                            id="editor_validation"
                                        />
                                    </div>
                                        {
                                            'undefined' != typeof fieldData.validations && 'undefined' != typeof fieldData.validations.specific_trip && fieldData.validations.specific_trip == true &&
                                            <div className="wp-travel-form-field input-trip-id">
                                                <label htmlFor="editor_label">{_wp_travel.setting_strings.field_editor.trip_ids}</label>
                                                <TextControl
                                                    value={fieldData.trip_ids}
                                                    placeholder={__('Enter multiple trip ids seperated with comma', 'wp-travel-pro')}
                                                    onChange={
                                                        (value) => {
                                                            let _fieldData = fieldData
                                                            _fieldData = JSON.parse(JSON.stringify(_fieldData))
                                                            _fieldData.trip_ids = value

                                                            setState((prevState) => {
                                                                return { ...prevState, fieldData: _fieldData }
                                                            })
                                                        }
                                                    }
                                                    required={false}
                                                    id="editor_label"
                                                />
                                            </div>
                                        }
                
                                        
            
                                </div>
                            }

                            <div>
                                <Button className="wp-traval-button-danger" isSecondary onClick={toggleVisible}>{_wp_travel.setting_strings.field_editor.field_editor_cancel }</Button>
                                <Button type="submit" isPrimary onClick={(e) => {
                                    if (jQuery('#field-editor-popup-form').parsley().validate()) {
                                        if ('undefined' != typeof isVisible) {

                                            let editorFields = enquiry_fields;
                                            let editorFieldName = 'enquiry_fields';
                                            if (fieldType) {
                                                switch (fieldType) {
                                                    case 'billing':
                                                        editorFields = billing_fields
                                                        editorFieldName = 'billing_fields';

                                                        break;
                                                    case 'traveller':
                                                        editorFields = traveller_fields
                                                        editorFieldName = 'traveller_fields';
                                                        break;
                                                }
                                            }
                                            if (!isNewField) {
                                                editorFields = editorFields.map((item) => {
                                                    if (item.key == fieldData.key) {
                                                        return fieldData
                                                    }
                                                    return item
                                                })
                                            } else {
                                                editorFields.push(fieldData)
                                            }
                                            updateSettings({ settings, field_editors: { ...settings.field_editors, [fieldType]: JSON.parse(JSON.stringify(editorFields)) } }) // field editor data.
                                            updateSettings({ settings, [editorFieldName]: JSON.parse(JSON.stringify(editorFields)) }) // for Temp load data in popup

                                            setState({
                                                isVisible: false,
                                                fieldData: []
                                            })
                                        }
                                    }

                                }}>
                                    {_wp_travel.setting_strings.field_editor.field_editor_save }
                                </Button>
                            </div>
                        </form>
                    </Modal>
                </div>
            )}
        </>
    }

    let field_pattern_multiple_traveler = 'undefined' != typeof settings.field_pattern_multiple_traveler ? settings.field_pattern_multiple_traveler : false

    return <>
        {
            _wp_travel.wp_settings.settings.enable_woo_checkout == 'yes' &&
            <TabPanel className="wp-travel-trip-edit-menu wp-travel-trip-edit-menu-horizontal wp-travel-trip-edit-menu-add-gap"
                activeClass="active-tab"
                onSelect={() => false}
                tabs={[
                    {
                        name: 'tripEnquiryFields',
                        title: _wp_travel.setting_strings.field_editor.trip_enquiry_fields,
                        className: 'tab-one',
                        content: TripEnquiryFields
                    },

                ]}>

                {(tab) => 'undefined' !== typeof tab.content ? <tab.content resetFields={resetFields} WPTravelFieldEditorPopover={WPTravelFieldEditorPopover} toggleVisible={toggleVisible} sortFields={sortFields} /> : <>{__('Error', 'wp-travel-pro')}</>}
            </TabPanel>
            ||
            <TabPanel className="wp-travel-trip-edit-menu wp-travel-trip-edit-menu-horizontal wp-travel-trip-edit-menu-add-gap"
                activeClass="active-tab"
                onSelect={() => false}
                tabs={[
                    {
                        name: 'tripEnquiryFields',
                        title: _wp_travel.setting_strings.field_editor.trip_enquiry_fields,
                        className: 'tab-one',
                        content: TripEnquiryFields
                    },
                    {
                        name: 'billingFields',
                        title: _wp_travel.setting_strings.field_editor.billing_fields,
                        className: 'tab-two',
                        content: BillingFields
                    },
                    {
                        name: 'travelerFields',
                        title: _wp_travel.setting_strings.field_editor.traveler_info_fields,
                        className: 'tab-three',
                        content: TravelerFields
                    },

                ]}>

                {(tab) => 'undefined' !== typeof tab.content ? <tab.content resetFields={resetFields} WPTravelFieldEditorPopover={WPTravelFieldEditorPopover} toggleVisible={toggleVisible} sortFields={sortFields} /> : <>{__('Error', 'wp-travel-pro')}</>}
            </TabPanel>
        }
       
        <br />
        {
            _wp_travel.wp_settings.settings.enable_woo_checkout == 'no' &&
            <>
                <h3>{_wp_travel.setting_strings.field_editor.field_editor_options }</h3>
                <PanelRow>
                    <label>
                        {_wp_travel.setting_strings.field_editor.multiple_traveler}
                        {hasFilter('wp_travel_settings_tab_field_editor_fields_tooltip', 'wp_travel') &&
                            applyFilters('wp_travel_settings_tab_field_editor_fields_tooltip', [])
                        }
                    </label>
                    <div className="wp-travel-field-value">

                        <ToggleControl
                            checked={field_pattern_multiple_traveler}
                            onChange={() => {
                                updateSettings({
                                    ...settings,
                                    field_pattern_multiple_traveler: !field_pattern_multiple_traveler
                                })
                            }
                            }
                        />
                        <p className="description">
                        {!hasFilter('wp_travel_settings_tab_field_editor_fields_tooltip', 'wp_travel') &&
                            (__('Use traveler info fields pattern.<br />', 'wp-travel-pro'),
                            _wp_travel.setting_strings.field_editor.multiple_traveler_tooltip )
                        }
                        </p>

                    </div>
                </PanelRow>
            </>
        }
        
    </>;
}

